import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function GoogleCallback() {
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const match = window.location.hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;
    if (!sessionId) { window.location.replace("/auth"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        localStorage.setItem("pb_token", data.token);
        const after = localStorage.getItem("pb_after_login");
        if (after) localStorage.removeItem("pb_after_login");
        window.location.replace(after && after.startsWith("/") ? after : "/profile");
      } catch (e) {
        setError(e.response?.data?.detail || "Google sign-in failed — try again");
        setTimeout(() => window.location.replace("/auth"), 2500);
      }
    })();
  }, []);

  return (
    <div className="min-h-screen bg-pb-bg flex items-center justify-center" data-testid="google-callback">
      <div className="text-center">
        <div className="w-10 h-10 border-2 border-pb-red border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-sm text-zinc-400 uppercase tracking-widest font-bold">{error || "Signing you in with Google…"}</p>
      </div>
    </div>
  );
}
